export const SITUACAO_MATRICULA = {
  // SITUACAO DE MATRICULA DO SISTEMA ESCOLAR

  0: "PENDENTE", // ---------------- ALUNO ESPERANDO MATRÍCULA SER RENOVADA NA 1º FASE DE MATRÍCULA
  1: "ATIVA", // ------------------- ALUNO ESTUDANDO
  2: "EM TRANSFERÊNCIA", // -------- ALUNO SOLICITOU TRANSFERÊNCIA E ESTÁ AGUARDANDO OUTRA ESCOLA CAPTURÁ-LO
  3: "FECHADA (OCULTADA)", // ------ ALUNO QUE ESTAVA COM SITUAÇÃO PENDENTE E NÃO RENOVOU
  4: "CONCLUÍDA", // --------------- ALUNO CONCLUIU O PERÍODO LETIVO EM QUESTÃO
  5: "CANCELADO", // --------------- MATRÍCULA CANCELADA POR MOTIVOS DE ERRO (APARECE NAS LISTAGENS)
  6: "INATIVO", // ----------------- MATRÍCULA INATIVADA NÃO APARECE NAS LISTAGENS
  7: "TRANSFERIDO", // ------------- QUANDO UMA NOVA MATRÍCULA É ATIVADA APÓS TRANSFERÊNCIA. A ANTERIOR FICA COM O STATUS TRANSFERIDO
  8: "RECLASSIFICADO", // ---------- ALUNO É MATRICULADO EM UMA CURSO DIFERENTE APÓS ANÁLISE E PERMISSÃO DA SMED
  9: "REALOCADO", // -------------- ALUNO É MATRICULADO EM UMA NOVA CURSO OU TURMA PARA CORREÇÃO NO SISTEMA
  10: "EVADIDO", // ---------------- ALUNO SE EVADIU ANTES DO TÉRMINO DO ANO LETIVO
  11: "DESISTENTE", //-------------- ALUNO DESISTIU ANTES DO TÉMINO DO ANO LETIVO
  12: "FECHADA", //------------------ MATRÍCULA FECHADA (APARECE NA LISTAGEM)
  13: "RENOVADA",
  14: "NÃO CONCLUÍDO",
  15: "AGENDADO",

  // 0: 'ATIVA', ------------------- SITUAÇÃO_MATRICULA: ATIVA
  // 1: 'CONCLUIDA', --------------- SITUAÇÃO_MATRICULA: CONCLUIDA + FECHADA
  // 2: 'TRANCADA', ---------------- REMOVIDA
  // 3: 'CANCELADO', --------------- SITUAÇÃO_MATRICULA: CANCELAD0
  // 4: 'PENDENTE', ---------------- SITUAÇÃO_MATRICULA: PENDENTE
  // 5: 'EM_TRANSFERENCIA', -------- SITUAÇÃO_MATRICULA: EM_TRANSFERÊNCIA
  // 6: 'TRANSFERIDO', ------------- SITUAÇÃO_MATRICULA: TRANSFERIDO
  // 7: 'EVADIDO', ----------------- SITUACAO_ACADEMICA: EVADIDO
  // 8: 'INATIVO', ----------------- SITUAÇÃO_MATRICULA: INATIVO
  // 9: 'DESISTENTE', -------------- SITUACAO_ACADEMICA: DESISTENTE
  // 10: 'RECLASSIFICACA', --------- SITUAÇÃO_MATRICULA: RECLASSIFICADA
  // 11: 'REALOCACAO', ------------- SITUAÇÃO_MATRICULA: REALOCACAO
  // 12: 'FALECIDO', --------------- SITUACAO_ACADEMICA: FALECIDO
  // 13: 'FECHADA' ----------------- REMOVIDA
};

export const SITUACAO_ACADEMICA = {
  // SITUAÇÃO ACADEMICA DO SISTEMA ESCOLAR

  0: "ABERTO", // ------------------ CURSANDO AINDA NÃO SE SABE SE O ALUNO FOI APROVADO, CONSERVADO ETC
  1: "APROVADO", // ---------------- ALUNO OBTEVE NOTA ACIMA DE MÉDIA ANUAL E FOI APROVADO
  2: "CONSERVADO", // -------------- ALUNO NÃO OBTEVE A MÉDIA ANUAL NECESSÁRIA PARA A SUA APROVAÇÃO
  3: "EVADIDO", //------------------ ALUNO PAROU DE FREQUENTAR A INSTITUIÇÃO E A INSTITUIÇÃO NÃO SABE O MOTIVO
  4: "DESISTENTE", // -------------- ALUNO PAROU DE FREQUENTAR A INSTITUIÇÃO E A INSTITUIÇÃO FOI COMUNICADA SOBRE O MOTIVO
  5: "FALECIDO", // ---------------- ALUNO FALECEU
  6: "TRANSFERIDO", // -------------- ALUNO SAIU DA INSTITUIÇÃO ANTES DO TÉRMINO
};

export const TIPO_USER = {
  0: "SECRETÁRIO ESCOLAR",
  1: "DIRETOR ESCOLAR",
  2: "PROFESSOR",
  3: "COORDENADOR PEDAGÓGICO",
  4: "NTI - PMVC",
  5: "NTI - SMED",
  6: "SMED - LEGALIZAÇÃO",
  7: "SMED - PEDAGÓGICO",
  8: "SMED - RECURSOS HUMANOS",
  9: "SMED - TABULAÇÃO",
  10: "CONSULTA",
};

export const LOCALIZACAO_ZONA = {
  1: "URBANA",
  2: "RURAL",
};

export const SITUACAO_FUNCIONAMENTO = {
  1: "EM ATIVIDADE",
  2: "PARALISADA",
  3: "EXTINTA",
};

export const SEXO = {
  0: "MASCULINO",
  1: "FEMININO",
};

export const RACA_COR = {
  0: "NÃO DECLARADA",
  1: "BRANCA",
  2: "PRETA",
  3: "PARDA",
  4: "AMARELA",
  5: "INDÍGENA",
};

export const TURNO = {
  0: "MATUTINO",
  1: "VESPERTINO",
  2: "NOTURNO",
  4: "INTEGRAL", //O EDF PULOU O NÚMERO 3. A IMPORTAÇÃO MANTEVE A ORDEM.
};

export const SITUACAO_TURMA = {
  0: "CONCLUIDO",
  1: "ATIVO",
  2: "PENDENTE",
  3: "INATIVO",
};

export const TIPO_ENSINO = {
  1: "ENSINO REGULAR",
  2: "EJA",
  3: "EDUCAÇÃO ESPECIAL",
  4: "ATIVIDADE COMPLEMENTAR",
  5: "PROJOVEM",
};

export const ETAPA = {
  0: "EDUCAÇÃO INFANTIL",
  1: "FUNDAMENTAL I",
  2: "FUNDAMENTAL II",
};

export const CURSO_NACIONAL = {
  1: "CRECHE 1 ANO",
  2: "CRECHE 2 ANOS",
  3: "CRECHE 3 ANOS",
  4: "EDUCAÇÃO INFANTIL - 04 ANOS",
  5: "EDUCAÇÃO INFANTIL - 05 ANOS",
  6: "1º ANO",
  7: "2º ANO",
  8: "3º ANO",
  9: "4º ANO",
  10: "5º ANO",
  11: "6º ANO",
  12: "7º ANO",
  13: "8º ANO",
  14: "9º ANO",
};

export const TIPO_SERVIDOR = {
  1: "DIRETOR",
  2: "COORDENADOR PEDAGÓGICO",
  3: "PROFESSOR",
};

export const CARGO_SERVIDOR = {
  1: "CARGO 1",
  2: "CARGO 2",
  3: "CARGO 3",
  4: "CARGO 4",
};

export const FUNCAO_SERVIDOR = {
  1: "DOCENTE",
  2: "AUXILIAR/ASSISTENTE EDUCACIONAL",
  3: "PROFISSIONAL/MONITOR DE ATIVIDADE  COMPLEMENTAR",
  4: "TRADUTOR E INTERPRETE DE LIBRAS",
  // 5: 'DOCENTE TITULAR - COORDENADOR DE TUTORIA (DE  MÓDULO OU DISCIPLINA) - EAD',
  // 6: 'DOCENTE TUTOR - AUXILIAR (DE MÓDULO OU DISCIPLINA) - EAD',
  7: "GUIA-INTERPRETE",
  8: "PROFISSIONAL DE APOIO ESCOLAR PARA ALUNO(A)S COM DEFICIENCIA (LEI 13.146/2015)",
  9: "SECRETARIO ESCOLAR",
  10: "AUXILIAR DE SECRETARIA",
  11: "DIRETOR",
  12: "VICE-DIRETOR",
  13: "COORDENADOR PEDAGÓGICO",
};

export const SITUACAO_FUNCIONAL_SERVIDOR = {
  1: "CONCURSADO/EFETIVO/ESTAVEL",
  2: "CONTRATO TEMPORARIO",
  3: "CONTRATO TERCEIRIZADO",
  4: "CONTRATO CLT",
};

export const MAIOR_ESCOLARIDADE_SERVIDOR = {
  1: "NÃO CONCLUIU O ENSINO FUNDAMENTAL",
  2: "ENSINO FUNDAMENTAL",
  7: "ENSINO MÉDIO",
  6: "EDUCAÇÃO SUPERIOR",
};

export const TIPO_ENSINO_MEDIO_SERVIDOR = {
  1: "FORMAÇÃO GERAL",
  2: "MODALIDADE NORMAL (MAGISTÉRIO)",
  3: "CURSO TÉCNICO",
  4: "MAGISTÉRIO INDÍGENA - MODALIDADE NORMAL",
};

export const POS_GRADUACAO_SERVIDOR = {
  "1": "ESPECIALIZACAO",
  "2": "MESTRADO",
  "3": "DOUTORADO",
};

export const AREA_POS_GRADUACAO_SERVIDOR = {
  99: "PROGRAMAS BÁSICOS",
  1: "EDUCAÇÃO",
  2: "ARTES E HUMANIDADES",
  3: "CIÊNCIAS SOCIAIS, COMUNICAÇÃO E INFORMAÇÃO",
  4: "NEGÓCIOS, ADMINISTRAÇÃO E DIREITO",
  5: "CIÊNCIAS NATURAIS, MATEMÁTICA E ESTATÍSTICA",
  6: "COMPUTAÇÃO E TECNOLOGIAS DA INFORMAÇÃO E COMUNICAÇÃO (TIC)",
  7: "ENGENHARIA, PRODUÇÃO E CONSTRUÇÃO",
  8: "AGRICULTURA, SILVICULTURA, PESCA E VETERINÁRIA",
  9: "SAÚDE E BEM-ESTAR",
  10: "SERVIÇOS",
};

export const SALA_LOCAL_DIFERENCIADO = {
  0: "NÃO",
  1: "SALA ANEXA",
  2: "UNIDADE DE ATENDIMENTO SOCIOEDUCATIVO",
  3: "UNIDADE PRISIONAL",
};

/****** CONSTANTES EDUCACENSO ******/

export const LOCALIZACAO_DIFERENCIADA_ESCOLA = {
  1: "ÁREA DE ASSENTAMENTO",
  2: "TERRA INDÍGENA",
  3: "ÁREA ONDE SE LOCALIZA COMUNIDADE REMANESCENTE DE QUILOMBOS",
  7: "A ESCOLA NÃO ESTÁ EM ÁREA DE LOCALIZAÇÃO DIFERENCIADA",
  8: "ÁREA ONDE SE LOCALIZA POVOS E COMUNIDADES TRADICIONAIS",
};

export const DEPENDENCIA_ADMINISTRATIVA = {
  1: "FEDERAL",
  2: "ESTADUAL",
  3: "MUNICIPAL",
  4: "PRIVADA",
};

export const REGULAMENTACAO_AUTORIZACAO = {
  0: "NÃO",
  1: "SIM",
  2: "EM TRAMITAÇÃO",
};

export const FORMA_OCUPACAO_PREDIO = {
  1: "PRÓPRIO",
  2: "ALUGADO",
  3: "CEDIDO",
};

export const RELATORIO_ALUNO_AGRUPAMENTO = {
  instituicao: "Instituição",
  turma: "Turma",
  curso: "curso",
  bairro: "Bairro",
};

export const STATUS_PRE_MATRICULA = {
  1: "PROCESSANDO",
  2: "ATIVO",
  3: "CANCELADO",
  4: "FINALIZADO",
};

export const STATUS_SUPORTE = {
  1: "EM ABERTO",
  2: "EM ANÁLISE",
  3: "FINALIZADO",
};

export const STATUS_EDUCACENSO = {
  1: "PENDENTE",
  2: "ARQUIVO GERADO",
  4: "MIGRADO",
  5: "FECHADO",
};

export const TIPO_DEFICIENCIA = {
  1: "Cegueira",
  2: "Baixa Visão",
  3: "Surdez",
  4: "Deficiência Auditiva",
  5: "Surdocegueira",
  6: "Deficiência Física",
  7: "Deficiência intelectual",
  8: "Deficiência Multipla",
  13: "Superdotação",
  14: "Transtorno do espectro autista",
  16: "Visão monocular",  
};